module.exports = __webpack_public_path__ + "img/drizzle.efe24d9b.svg";